import { render } from "./CancelButton.vue?vue&type=template&id=573bf4ad&scoped=true"
import script from "./CancelButton.vue?vue&type=script&lang=js"
export * from "./CancelButton.vue?vue&type=script&lang=js"

import "./CancelButton.vue?vue&type=style&index=0&id=573bf4ad&lang=less&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573bf4ad"]])

export default __exports__